import { render, staticRenderFns } from "./NotificationsDetail.vue?vue&type=template&id=4f78f33e&scoped=true"
import script from "./NotificationsDetail.vue?vue&type=script&lang=ts"
export * from "./NotificationsDetail.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsDetail.vue?vue&type=style&index=0&id=4f78f33e&lang=scss"
import style1 from "./NotificationsDetail.vue?vue&type=style&index=1&id=4f78f33e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78f33e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f78f33e')) {
      api.createRecord('4f78f33e', component.options)
    } else {
      api.reload('4f78f33e', component.options)
    }
    module.hot.accept("./NotificationsDetail.vue?vue&type=template&id=4f78f33e&scoped=true", function () {
      api.rerender('4f78f33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifications/components/NotificationsDetail.vue"
export default component.exports